export default {
  // Navbar
  nav: {
    howItWorks: 'Cómo funciona',
    newUpload: 'Nueva subida',
    signInSave: 'Inicia sesión para guardar',
    upload: 'Subir',
    files: 'Archivos',
    account: 'Cuenta',
    signOut: 'Cerrar sesión',
    pricing: 'Precios',
    legal: 'Legal',
    goToApp: 'Ir a la App',
    signInGoogle: 'Iniciar sesión con Google',
  },

  // Landing
  landing: {
    formatsTitle: 'Abre 70 tipos de archivo',
    formatsLink: 'Ver todos los formatos',
    eyebrow: 'Visor 3D para Revit, IFC, STEP y 70 tipos de archivo',
    ctaUpload: 'Nueva subida',
    ctaNoAccount: 'Pruébalo sin registrarte',
    viewerCaption: 'Modelo IFC en vivo · arrastra para orbitar',
    heroTitle1: 'Compartir archivos BIM.',
    heroTitle2: 'Simple y rápido.',
    heroSubtitle: 'Abre Revit, IFC, STEP, Tekla, Rhino, DXF, OBJ, FBX, STL y muchos más archivos 3D en el navegador. Compártelos con un enlace o incrusta el visor en tu web.',
    heroFree: 'Gratis — 10 archivos al mes',
    footerRights: 'Todos los derechos reservados.',
  },

  // Upload
  upload: {
    bundled: '{count} archivos empaquetados en {name}',
    bundleHint: '¿Modelo con materiales o texturas (OBJ + MTL, DAE, 3DS…)? Suelta la carpeta entera o un ZIP.',
    guestNotice: 'Modo invitado: hasta {limit} archivos. Inicia sesión para guardarlos y compartir enlaces.',
    openViewer: 'Abrir visor',
    title: 'Subir Archivos',
    uploadsThisMonth: 'subidas este mes',
    remaining: 'restantes',
    dragDrop: 'Arrastra y suelta archivos aquí',
    orClick: 'o haz clic para buscar',
    formats: 'IFC, DWG, PDF, DXF, BCF, GLTF, GLB, OBJ, FBX, DAE, STL, 3MF, PLY, USDZ y cualquier otro tipo de archivo',
    limitReached: 'Límite mensual alcanzado',
    limitReachedDesc: 'Has usado las {limit} subidas de este mes.',
    upgradePro: 'Actualizar a Pro →',
    uploading: 'Subiendo...',
    uploadComplete: '¡Subida completada!',
    filesUploaded: '{count} archivo(s) subido(s) correctamente.',
    viewMyFiles: 'Ver mis archivos',
    uploadMore: 'Subir más',
    uploadFailed: 'Error en la subida',
    tryAgain: 'Intentar de nuevo',
    limitError: 'Límite mensual de subidas alcanzado. Actualiza a Pro para más subidas.',
    partialUpload: 'Solo puedes subir {max} archivo(s) más este mes. Subiendo los primeros {max}.',
    fileTooLarge: '"{name}" supera el límite de {limit} para tu plan. Actualiza a Pro para subir archivos más grandes.',
  },

  // Files
  files: {
    title: 'Mis Archivos',
    uploadFiles: 'Subir archivos',
    loading: 'Cargando tus archivos...',
    noFiles: 'Aún no hay archivos',
    noFilesDesc: 'Sube tu primer archivo para empezar.',
  },

  // Account
  account: {
    title: 'Cuenta',
    profile: 'Perfil',
    userId: 'ID de Usuario',
    authProvider: 'Proveedor de Auth',
    subscription: 'Suscripción',
    currentPlan: 'Plan Actual',
    monthlyLimit: 'Límite Mensual de Subidas',
    price: 'Precio',
    free: 'Gratuito',
    filesPerMonth: '{count} archivos / mes',
    unlimited: 'Ilimitado',
    freeForever: '0€ / siempre',
    custom: 'Personalizado',
    viewPlans: 'Ver planes y mejorar →',
    upgradeToPro: 'Mejorar a Pro',
    manageSubscription: 'Gestionar suscripción',
    processing: 'Procesando...',
    usageTitle: 'Uso de este Mes',
    filesUploaded: 'archivos subidos este mes',
    unlimitedRemaining: 'Subidas ilimitadas restantes',
    uploadsRemaining: '{count} subida(s) restante(s) este mes',
    limitReached: 'Límite mensual alcanzado. Se reinicia el próximo mes.',
    session: 'Sesión',
    signOutDesc: 'Cerrar sesión en este dispositivo.',
    signOut: 'Cerrar sesión',
  },

  // Account: Claude / MCP API keys
  mcp: {
    title: 'Claude (MCP)',
    serverUrl: 'URL del servidor MCP',
    desc: 'Usa BimDrop desde Claude: pídele que suba archivos, los liste y cree enlaces para compartir.',
    keyName: 'Nombre de la clave',
    keyNamePlaceholder: 'Nombre de la clave, p. ej. Claude Code',
    create: 'Crear clave',
    newKeyWarning: 'Copia esta clave ahora. No la volverás a ver.',
    claudeCode: 'Claude Code',
    otherClients: 'Otros clientes MCP (configuración JSON)',
    copy: 'Copiar',
    copied: 'Copiado',
    created: 'creada el {date}',
    lastUsed: 'último uso {date}',
    neverUsed: 'sin usar',
    revoke: 'Revocar clave',
    revokeConfirm: '¿Revocar "{name}"? Claude perderá el acceso con esta clave.',
    error: 'Algo ha fallado. Inténtalo de nuevo.',
    claudeApps: 'claude.ai y Claude Desktop',
    claudeAppsSteps: 'Ve a Ajustes → Conectores → Añadir conector personalizado, pega la URL de arriba e inicia sesión con Google.',
    claudeCodeSteps: 'Después ejecuta /mcp en Claude Code e inicia sesión con Google.',
    connectedApps: 'Apps conectadas',
    connected: 'conectada el {date}',
    disconnect: 'Desconectar',
    disconnectConfirm: '¿Desconectar "{name}"? Perderá el acceso a tus archivos.',
    apiKeys: 'Claves API',
    apiKeysDesc: 'Para scripts y clientes MCP sin inicio de sesión. Envía la clave como "Authorization: Bearer …".',
  },

  // OAuth consent page (Claude connectors)
  oauth: {
    loading: 'Comprobando la solicitud…',
    invalid: 'Esta solicitud de conexión no es válida',
    error: 'Algo ha fallado. Inténtalo de nuevo.',
    title: '¿Permitir que {app} acceda a tu cuenta de BimDrop?',
    unverified: 'BimDrop no ha verificado esta app. Continúa solo si confías en ella.',
    signInPrompt: 'Inicia sesión para continuar.',
    signedInAs: 'Sesión iniciada como {email}.',
    switchAccount: 'Usar otra cuenta',
    permissionsTitle: 'Podrá:',
    permUpload: 'Subir archivos a tu cuenta',
    permList: 'Ver tus archivos y sus enlaces',
    permShare: 'Crear y revocar enlaces para compartir',
    redirectNote: 'Al permitirlo, volverás a {host}.',
    allow: 'Permitir',
    deny: 'Cancelar',
    redirecting: 'Volviendo a {host}…',
  },

  // Viewer
  viewer: {
    loadingModel: 'Cargando modelo 3D…',
    loadError: 'No se pudo cargar el modelo',
    back: 'Volver',
    fitView: 'Ajustar vista',
    projection: 'Proyección',
    hideSelected: 'Ocultar elemento seleccionado',
    isolateSelected: 'Aislar elemento seleccionado',
    showAll: 'Mostrar todos los elementos',
    share: 'Compartir',
    loading: 'Cargando datos del archivo...',
    processingBtlx: 'Procesando BTLx...',
    backToFiles: 'Volver a archivos',
    notPreviewable: 'Este tipo de archivo no se puede previsualizar.',
    btlxProcessing: 'Se está generando el modelo 3D. Espera un momento y actualiza.',
    btlxError: 'Error en el procesamiento. No se pudo generar el modelo 3D.',
    btlxQueued: 'El modelo 3D está en cola para procesarse. Vuelve a comprobar en breve.',
    parts: 'piezas',
    layers: 'capas',
  },

  // Shared Viewer
  shared: {
    loading: 'Cargando modelo compartido...',
    linkNotFound: 'Enlace no encontrado',
    linkExpired: 'Este enlace compartido no existe o ha expirado.',
    goToBimdrop: 'Ir a Bimdrop',
    sharedVia: 'Este archivo ha sido compartido contigo a través de Bimdrop.',
    download: 'Descargar',
    tryFree: 'Prueba Bimdrop gratis →',
    hideSelected: 'Ocultar seleccionado',
    isolateSelected: 'Aislar seleccionado',
    showAll: 'Mostrar todo',
  },

  // FileCard
  fileCard: {
    generating3D: 'Generando modelo 3D...',
    processingFailed: 'Error en el procesamiento',
    queued: 'En cola para procesar',
    downloadTooltip: 'Descargar',
    shareTooltip: 'Compartir',
    editTooltip: 'Editar',
    deleteTooltip: 'Eliminar',
    confirmDelete: 'Haz clic de nuevo para confirmar',
    confirm: '¿Confirmar?',
    view2D: 'Ver 2D',
    view3D: 'Ver 3D',
    fileName: 'Nombre del archivo',
    description: 'Descripción',
    descriptionPlaceholder: 'Añade una descripción...',
    save: 'Guardar',
    cancel: 'Cancelar',
  },

  // Share Modal
  shareModal: {
    shareTitle: 'Compartir "{name}"',
    viewer: 'Visor',
    embed: 'Incrustar',
    shareFile: 'Compartir Archivo',
    viewerDesc: 'Comparte un enlace al visor. Cualquiera con este enlace puede ver o descargar el archivo en su navegador — sin necesidad de cuenta.',
    generatingLink: 'Generando enlace seguro...',
    tryAgain: 'Intentar de nuevo',
    copied: '¡Copiado!',
    copy: 'Copiar',
    recipientsCanView: 'Los destinatarios pueden ver o descargar el archivo directamente',
    email: 'Email',
    whatsapp: 'WhatsApp',
    embedDesc: 'Pega este código en el HTML de tu web para incrustar un visor interactivo:',
    generatingEmbed: 'Generando código de incrustación...',
    directLinkDesc: 'Copia el enlace de descarga directa o envíalo por email / WhatsApp:',
  },

  // Sesiones de invitado (anónimas)
  guest: {
    badge: 'Invitado',
    saveTitle: 'Guarda tus archivos',
    saveDesc: 'Estás en una sesión de invitado. Inicia sesión con Google para conservar tus archivos y compartirlos.',
    shareLocked: 'Inicia sesión para compartir',
    shareLockedDesc: 'Los enlaces públicos y las incrustaciones necesitan una cuenta. Tus archivos pasan a tu cuenta.',
    accountDesc: 'Sesión de invitado. Pierdes tus archivos si borras los datos del navegador o cierras sesión.',
  },

  // Selector de tema
  theme: {
    system: 'Tema: sistema',
    light: 'Tema: claro',
    dark: 'Tema: oscuro',
  },

  // Cookie Banner
  cookies: {
    message: 'Usamos cookies para mejorar tu experiencia. Al usar Bimdrop, aceptas nuestra',
    cookiePolicy: 'política de cookies',
    accept: 'Aceptar',
  },

  // Pricing
  pricing: {
    title: 'Precios simples y transparentes',
    subtitle: 'Empieza gratis. Mejora cuando lo necesites.',
    free: 'Gratuito',
    pro: 'Pro',
    enterprise: 'Empresa',
    forever: 'siempre',
    perMonth: '/mes',
    freeDesc: 'Perfecto para empezar',
    proDesc: 'Para profesionales y equipos pequeños',
    enterpriseDesc: 'Para organizaciones con necesidades avanzadas',
    getStarted: 'Empezar',
    comingSoon: 'Próximamente',
    upgrade: 'Mejorar a Pro',
    processing: 'Procesando...',
    contactUs: 'Contáctanos',
    popular: 'Popular',
    // Features
    freeF1: '10 subidas de archivos al mes',
    freeF2: 'Comparte por enlace, email y WhatsApp',
    freeF3: 'Incrusta archivos en webs',
    freeF4: 'Gestión básica de archivos',
    freeF5: '100 MB tamaño máximo',
    proF1: '150 subidas de archivos al mes',
    proF2: 'Todo lo del plan Gratuito',
    proF3: '1 GB tamaño máximo',
    proF4: 'Marca personalizada en incrustaciones',
    proF5: 'Soporte prioritario',
    proF6: 'Analíticas y seguimiento de descargas',
    entF1: 'Todo lo del plan Pro',
    entF2: 'Tamaño de archivo ilimitado',
    entF3: 'SSO y gestión de equipos',
    entF4: 'Dominio personalizado',
    entF5: 'SLA y soporte dedicado',
    entF6: 'Acceso API',
    home: 'Inicio',
    legalCookies: 'Legal y Cookies',
  },

  // Legal
  legal: {
    title: 'Legal y Política de Cookies',
    lastUpdated: 'Última actualización: Marzo 2026',
  },

  // How it works page
  how: {
    fmtTekla: 'Modelos de Tekla Structures 2020+: sube la carpeta del modelo en un ZIP (beta)',
    fmtFab: 'Archivos de fabricación: madera (BTLX) y piezas de acero (DSTV NC1)',
    exportTitle: 'Exporta desde tu software',
    exportNote: 'Los nombres de los menús cambian un poco entre versiones.',
    exportRevit1: 'Los proyectos de Revit 2023–2025 se abren directamente: sube el .rvt (beta).',
    exportRevit2: 'Para el modelo completo u otras versiones: Archivo → Exportar → IFC.',
    exportRevit3: 'Elige IFC4 Reference View o IFC 2x3 Coordination View 2.0 y sube el .ifc.',
    exportTekla1: 'Modelo: Archivo → Exportar → IFC, tipo de exportación «Coordination view», y sube el .ifc.',
    exportTekla2: 'Fabricación: Fabricación → Archivos NC (DSTV). Sube los .nc1 o un ZIP de la carpeta.',
    exportTekla3: 'Cada NC1 se abre como una pieza de acero con su perfil, taladros y marca.',
    fmtRvt: 'Proyectos de Revit 2023–2025, convertidos en tu navegador (beta)',
    fmtCad: 'CAD sólido: ensamblajes con nombres y colores',
    fmtMore: 'X, OFF, 3DS, PLY, VRML, CityJSON y más. DWG y PDF se guardan para descargar.',
    eyebrow: 'Cómo funciona',
    title: 'De archivo a enlace compartido en tres pasos',
    subtitle: 'Suelta un archivo BIM o CAD, míralo en 3D en el navegador y envía un enlace. Sin plugins ni instalaciones.',
    s1Title: 'Suelta tu archivo',
    s1Desc: 'Arrastra un archivo a la zona de subida o elígelo desde tu ordenador. Puedes probarlo sin cuenta.',
    s1P1: 'IFC, DXF, GLB, OBJ, FBX, DAE, STL, 3MF, USDZ, BTLX, DWG, PDF y más',
    s1P2: 'Hasta 100 MB en Free y 1 GB en Pro',
    s1P3: 'Sin registro para tus primeros archivos',
    s2Title: 'Míralo en 3D',
    s2Desc: 'El modelo se abre directamente en el navegador. Orbita a su alrededor, haz clic en un elemento para ver sus propiedades, oculta o aísla piezas.',
    s2P1: 'Atributos y conjuntos de propiedades IFC',
    s2P2: 'Planos DXF en 2D, GLB, GLTF y STL en 3D',
    s2P3: 'Archivos BTLX de madera convertidos a 3D automáticamente',
    s3Title: 'Comparte un enlace',
    s3Desc: 'Inicia sesión con Google para obtener un enlace público. Cualquiera puede abrir el visor, sin cuenta.',
    s3P1: 'Copia el enlace o envíalo por email o WhatsApp',
    s3P2: 'Incrusta el visor en tu web con un solo fragmento',
    s3P3: 'Las previsualizaciones del enlace muestran una miniatura del modelo',
    mockReady: 'Listo',
    mockSelected: 'Seleccionado',
    mockSite: 'Tu web',
    accountsTitle: 'Con cuenta o sin ella',
    guestTitle: 'Sin cuenta',
    guestDesc: 'Ideal para probar Bimdrop con tu propio archivo.',
    guestF1: '3 subidas de hasta 100 MB',
    guestF2: 'Visualización en 3D y 2D',
    guestF3: 'Los archivos solo se guardan en este navegador',
    accountTitle: 'Con una cuenta gratuita de Google',
    accountDesc: 'Conserva tus archivos y compártelos.',
    accountF1: '10 subidas al mes',
    accountF2: 'Enlaces públicos e incrustaciones',
    accountF3: 'Tus archivos en todos tus dispositivos',
    formatsTitle: 'Formatos compatibles',
    fmtIfc: 'Modelo 3D con propiedades',
    fmtDxf: 'Plano 2D, o 3D si tiene entidades 3D',
    fmtGlb: 'Modelo 3D, incluidos los exports de SketchUp y de impresión 3D',
    fmtBtlx: 'Datos de mecanizado de madera, convertidos a 3D',
    fmtOther: 'Se guardan y comparten para descargar',
    ctaTitle: 'Pruébalo con tu propio archivo',
  },

  // Viewer workspace (toolbar, panels, saved views)
  ws: {
    frame: 'Unidades y orientación',
    units: 'Unidades del modelo',
    upAxis: 'Eje vertical',
    upY: 'Y arriba',
    upZ: 'Z arriba',
    toolSelect: 'Seleccionar',
    toolMeasure: 'Medir',
    toolNote: 'Añadir nota',
    toolClip: 'Sección',
    fit: 'Ajustar vista',
    presets: 'Vistas',
    presetIso: 'Isométrica',
    presetTop: 'Planta',
    presetFront: 'Alzado frontal',
    presetBack: 'Alzado posterior',
    presetLeft: 'Izquierda',
    presetRight: 'Derecha',
    projection: 'Perspectiva / ortogonal',
    walk: 'Modo paseo',
    walkHint: 'Arrastra para mirar · WASD o flechas para moverte · Esc para salir',
    hide: 'Ocultar',
    isolate: 'Aislar',
    showAll: 'Mostrar todo',
    color: 'Color',
    clearColors: 'Quitar colores',
    xray: 'Rayos X',
    screenshot: 'Captura',
    fullscreen: 'Pantalla completa',
    exitFullscreen: 'Salir de pantalla completa',
    clipX: 'Sección X',
    clipY: 'Sección Y',
    clipZ: 'Sección Z',
    clipFace: 'Haz clic en una cara para cortar',
    clipClear: 'Quitar secciones',
    panel: 'Panel',
    panelModel: 'Modelo',
    panelCategories: 'Categorías',
    panelLayers: 'Capas',
    panelViews: 'Vistas',
    panelNotes: 'Notas',
    panelMeasures: 'Medidas',
    panelProperties: 'Propiedades',
    treeLoading: 'Cargando estructura…',
    treeEmpty: 'Sin estructura disponible',
    groupsEmpty: 'Nada que mostrar',
    viewsAdd: 'Guardar vista actual',
    viewsNamePlaceholder: 'Nombre de la vista',
    viewsEmpty: 'Guarda posiciones de cámara para guiar a quien abra el enlace.',
    viewDefaultName: 'Vista {n}',
    notesEmpty: 'Usa la herramienta de notas para anclar comentarios al modelo.',
    notePlaceholder: 'Escribe una nota…',
    noteAdd: 'Añadir nota',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    saveEdit: 'Guardar',
    measuresEmpty: 'Usa la herramienta de medir y haz clic en dos puntos.',
    measureClear: 'Borrar todo',
    measureHint: 'Haz clic en dos puntos para medir · Esc para cancelar',
    noteHint: 'Haz clic en el modelo para colocar una nota',
    clipHint: 'Haz clic en una cara para añadir una sección · arrastra las flechas para moverla',
    selectionEmpty: 'Selecciona un elemento para ver sus propiedades',
    focus: 'Centrar',
    save: 'Guardar vista',
    saving: 'Guardando…',
    saved: 'Vista guardada',
    saveError: 'No se pudo guardar la vista',
    tooBig: 'Esta vista es demasiado grande para guardarla. Quita algunos elementos ocultos o notas.',
    unsaved: 'Cambios sin guardar',
    resetShared: 'Volver a la vista compartida',
    discard: 'Descartar cambios',
    ownerHint: 'Lo que guardes aquí es lo que verá quien abra el enlace.',
    sharedBadge: 'Vista compartida',
    shortcuts: 'Atajos de teclado',
    close: 'Cerrar',
    noteBy: 'Nota',
    tour: 'Vistas guiadas',
  },

  // Revit files (rvt-rs)
  revit: {
    reading: 'Leyendo archivo de Revit…',
    converting: 'Convirtiendo el modelo de Revit a IFC…',
    localHint: 'Se convierte en tu navegador: el archivo no se envía a ningún sitio.',
    unsupportedTitle: 'Este archivo de Revit aún no se puede ver en 3D',
    unsupportedDesc: 'Revit {version}, {kind}. La vista 3D funciona con proyectos de Revit 2023, 2024 y 2025.',
    exportHint: 'En Revit: Archivo → Exportar → IFC, y sube aquí el IFC para ver el modelo completo.',
    download: 'Descargar original',
    error: 'No se pudo leer este archivo de Revit',
    betaHint: 'Convertido desde Revit en tu navegador con rvt-rs. Algunos elementos están simplificados (puertas, ventanas y mobiliario pueden salir como cajas).',
    kind_project: 'proyecto',
    kind_family: 'familia',
    kind_template: 'plantilla',
    kind_unknown: 'archivo',
  },

  // SEO
  seo: {
    howTitle: 'Cómo funciona — sube, visualiza y comparte archivos BIM',
    howDesc: 'Suelta un Revit, IFC, STEP, DXF o cualquiera de 70 tipos de archivo 3D, míralo en el navegador y compártelo con un enlace o incrustado. Así funciona Bimdrop paso a paso.',
    landingTitle: 'Abre y comparte Revit, IFC, STEP y archivos 3D con un enlace',
    landingDesc:
      'Bimdrop abre Revit, IFC, STEP, IGES, Rhino, Tekla, DSTV, DXF, OBJ, FBX, glTF, STL y 70 tipos de archivo en el navegador, sin instalar nada. Compártelos con un enlace o incrusta un visor 3D interactivo.',
    pricingTitle: 'Precios — Planes Free, Pro y Enterprise',
    pricingDesc:
      'Precios simples y transparentes para compartir archivos BIM. Empieza gratis con 10 subidas al mes. Mejora a Pro para más límites, archivos más grandes y analíticas.',
    legalTitle: 'Aviso legal y política de cookies',
    legalDesc:
      'Aviso legal, términos del servicio y política de cookies de Bimdrop.',
  },
} as const
